<template>
    <div>
        <h4 class="text-center">ou entrez avec :</h4>
        <div class="row justify-content-center" v-if="!isLoading">
            <v-facebook-login-scope
                    @login="facebookAuth($event)"
                    app-id="643671699786946"
            >
                <a
                        @click="scope.login"
                        class="mx-2 font-20"
                        slot-scope="scope"
                        type="button"
                >{{ scope.text }}<i class="fab fa-facebook-f"></i
                ></a>
            </v-facebook-login-scope>
            <a @click="googleAuth" class="mx-2 font-20" type="button"
            ><i class="fab fa-google"></i
            ></a>
        </div>
        <h5 class="text-center" v-if="isLoading">
            <b-spinner class="align-middle" label="Spinning" small></b-spinner>
            <span class="align-middle">S'il vous plaît, attendez..</span>
        </h5>
    </div>
</template>

<script>
    import {VFBLoginScope as VFacebookLoginScope} from 'vue-facebook-login-component';

    export default {
        name: 'socialLogin',
        components: {
            VFacebookLoginScope
        },
        data() {
            return {
                errorMsg: '',
                isLoading: false
            };
        },
        methods: {
            googleAuth() {
                this.isLoading = true;
                this.errorMsg = null;
                this.$googleAuth().directAccess();
                const _self = this;
                this.$googleAuth().signIn(
                    function (googleUser) {
                        _self.$store
                            .dispatch('socialSignIn', {
                                provider: 'google',
                                token: googleUser.xc.id_token
                            })
                            .then(
                                () => {
                                    _self.isLoading = false;
                                }
                            ).catch(err => {
                            _self.errorMsg = err.response.data;
                            _self.$emit('error', _self.errorMsg);
                            _self.isLoading = false;
                        });
                    },
                    function (error) {
                        if (error.error != 'popup_closed_by_user') {
                            _self.errorMsg = 'An unknown error occurred.';
                            _self.$emit('error', _self.errorMsg);
                        }
                        _self.isLoading = false;
                    }
                );
            },
            facebookAuth(data) {
                if (data) {
                    this.isLoading = true;
                    this.$store
                        .dispatch('socialSignIn', {
                            provider: 'facebook',
                            token: data.authResponse.accessToken
                        })
                        .then(
                            () => {
                                this.isLoading = false;
                            },
                            () => {
                                this.errorMsg = 'An unknown error occurred.';
                                this.$emit('error', this.errorMsg);
                                this.isLoading = false;
                            }
                        );
                }
            }
        }
    };
</script>

<style scoped></style>
